export default __webpack_public_path__ + "static/logo-b9f72fea96caa8fc7690ca6baf902ebe.jpg";